<template>
	<div>
		<headTip></headTip>
		<userHead></userHead>
		<div class="userInfo">
			<div class="userInfo_left">
				<userLeft></userLeft>
			</div>
			<div class="userInfo_right">
				<router-view></router-view>
			</div>
		</div>
		<footerTip></footerTip>
	</div>
</template>

<script>
	import headTip from '../../components/headTip.vue'

	import userLeft from './components/userLeft.vue'
	import footerTip from '../../components/footerTip.vue'
	import userHead from './components/userHead.vue'
	export default {
		components: {
			headTip,
			footerTip,
			userHead,
			userLeft
		},

		created() {

			console.log(this.$route.query.text)
			console.log(545455554)

			let click_module = sessionStorage.getItem('click_module')

			if(click_module){
				console.log(click_module)
			}
		}

	}
</script>

<style scoped>

	/**滚动条的宽度*/
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	/*滚动条的滑块*/
	::-webkit-scrollbar-thumb {
		background-color: rgb(185, 221, 255);
		border-radius: 5px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(24,144,255,.8);
	}
	.userInfo {
		width: 1200px;
		margin: -30px auto 0;
		min-height: calc(100vh - 172px);;
		display: flex;
		justify-content: space-between;
	}

	.userInfo_left {
		width: 280px;
		/* height: 710px; */
	}

	.userInfo_right {
		width: calc(100% - 300px);
		/* height: 710px; */
	}

	/*.zjxPageFooter{
		position: fixed;
		bottom: 0;
	}*/
</style>
